import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types/index';

import { initialState } from './slice';

const selectDomain = (state: RootState) =>
  state.dataSecurityOverview || initialState;

export const selectDataSecurityOverview = createSelector(
  [selectDomain],
  state => state,
);
